import { useParams } from "react-router-dom";
import ActivationGeneralConfig from "./ActivationGeneralConfig";

const StarlinkConfig = () => {
	const { id } = useParams();
	const canEdit = true;
	const canUpdate = true;
	return (
		<div className="space-y-4">
			<ActivationGeneralConfig id={id} canEdit={canEdit} canUpdate={canUpdate} />
		</div>
	);
};

export default StarlinkConfig;
